
import React , {Fragment , useContext, useState } from 'react';
import { Formik , Form , ErrorMessage, Field, useFormik } from 'formik';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cropper from 'react-easy-crop';
import { UserContext } from '../../../Context/UserContext.js';
import * as Yup from 'yup';



export default function AddCompanyWithCrop() {
   const navigate = useNavigate();
   const { userToken } = useContext(UserContext);

   const [imageSrc, setImageSrc] = useState(null);
   const [crop, setCrop] = useState({ x: 0, y: 0 });
   const [zoom, setZoom] = useState(1);
   const [croppedArea, setCroppedArea] = useState(null);

   const onCropComplete = (_, croppedAreaPixels) => {
      setCroppedArea(croppedAreaPixels);
   };

   const handleFileChange = (e, setFieldValue) => {
      const file = e.target.files[0];
      if (!file) return;

      setFieldValue("file", file);
      const reader = new FileReader();
      reader.onload = () => setImageSrc(reader.result);
      reader.readAsDataURL(file);
   };

   const cropImage = async (imageSrc, croppedArea) => {
      const img = new Image();
      img.src = imageSrc;
      await new Promise((r) => (img.onload = r));

      const canvas = document.createElement("canvas");
      canvas.width = 150;
      canvas.height = 150;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
         img,
         croppedArea.x,
         croppedArea.y,
         croppedArea.width,
         croppedArea.height,
         0,
         0,
         150,
         150
      );

      return new Promise((resolve) =>
         canvas.toBlob(resolve, 'image/jpeg')
      );
   };



   const handleSubmit = async (values, { setSubmitting }) => {
      try {
         const croppedBlob = await cropImage(imageSrc, croppedArea);
         const formData = new FormData();
         formData.append("name", values.name);
         formData.append("description", values.description);
         formData.append("address", values.address);
         formData.append("phone", values.phone);
         formData.append("email", values.email);
         formData.append("service", values.service);
         formData.append("file", croppedBlob, "cropped.jpg");

         const headers = {
         'enctype': 'multipart/form-data',
         token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
         };

         const { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/company`, formData, { headers });

         toast.success(data.message || "Company added");
         navigate("/dashBoard/companyDashboard");

      } catch (err) {
         toast.error(err.response?.data?.message || "Error while uploading");
      }

      setSubmitting(false);
   };

   const initialValues = {
      name: "",
      description: "",
      address: "",
      phone: "",
      email: "",
      service:"" ,
      file: null,
   }

   const validationSchema = Yup.object().shape({
      name: Yup.string().required("اسم الشركة مطلوب"),
      description: Yup.string().required("الوصف مطلوب"),
      address: Yup.string().required("العنوان مطلوب"),
      phone: Yup.string().required("رقم الهاتف مطلوب"),
      email: Yup.string().email("صيغة الإيميل غير صحيحة").required("الإيميل مطلوب"),
      service: Yup.string().required(" مجال التخصص مطلوب"),
      file: Yup.mixed().required("الصورة مطلوبة")
   });

   return (
      <div className="container mt-5">
         <div className="row">
            <div className="col-md-10 offset-md-1">
               <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                  {({ setFieldValue, isSubmitting }) => (
                     <Form className="m-auto">
                        <h1 className="main-header">إضافة شركة</h1>
                        <div className="under-header mb-4"></div>

                        <div className="mb-3">
                           <label  htmlFor='name'>اسم الشركة</label>
                           <Field type="text"  name="name"  id='name' className="form-control" />
                           <ErrorMessage name="name" component="div" className="text-danger" />
                        </div>

                        <div className="mb-3">
                           <label htmlFor='description'>الوصف</label>
                           <Field as="textarea" id="description" name="description" placeholder="اكتب وصف الشركة" rows="3" className="form-control"/>                           
                           <ErrorMessage name="description" component="div" className="text-danger" />
                        </div>

                        <div className="mb-3">
                           <label htmlFor='address'>العنوان</label>
                           <Field type="text"  name="address" id='address' className="form-control" />
                           <ErrorMessage name="address" component="div" className="text-danger" />
                        </div>

                        <div className="mb-3">
                           <label htmlFor='phone'>رقم الهاتف</label>
                           <Field type="tel"  name="phone" id='phone' className="form-control" />
                           <ErrorMessage name="phone" component="div" className="text-danger" />
                        </div>

                        <div className="mb-3">
                           <label  htmlFor='email'>الإيميل</label>
                           <Field type="email"  name="email" id='email' className="form-control" />
                           <ErrorMessage name="email" component="div" className="text-danger" />
                        </div>

                        <div className="my-4">
                           <label htmlFor="service" className="form-label">مجال التخصص</label>
                           <Field as="select" name="service" id="service" className="form-control">
                              <option value="">مجال التخصص</option>
                                 <option value="analysis">
                                    Analysis
                                 </option>
                                 <option value="radiology">
                                    Radiology
                                 </option>
                                 <option value="pharmacy">
                                    Pharmacy
                                 </option>
                                 <option value="hospital">
                                    Hospital
                                 </option>
                           </Field>
                           <ErrorMessage name="service" component="div" className="alert alert-danger mt-4 p-2"/>
                        </div>

                        <div className="mb-3">
                           <label  htmlFor='image'>الصورة</label>
                           <input type="file" accept="image/*" id='image' className="form-control" onChange={(e) => handleFileChange(e, setFieldValue)} />
                           <ErrorMessage name="file" component="div" className="text-danger" />
                        </div>

                        {imageSrc && (
                           <div className="mb-3" style={{ width: 300, height: 300, position: 'relative' }}>
                              <Cropper
                                 image={imageSrc}
                                 crop={crop}
                                 zoom={zoom}
                                 aspect={1}
                                 onCropChange={setCrop}
                                 onZoomChange={setZoom}
                                 onCropComplete={onCropComplete}
                              />
                           </div>
                        )}

                        <div className="text-center mt-4">
                           <button type="submit" disabled={isSubmitting} className="btn bg-main w-50">
                              {isSubmitting ? <i className="fa fa-spinner fa-spin"></i> : "إضافة"}
                           </button>
                        </div>
                     </Form>
                  )}
               </Formik>
            </div>
         </div>
      </div>
   );
};
